import HttpClient from './httpClient';

class PublicAccessController extends HttpClient {
  /**
   * institutionSignin public controller for checking if an email is part of university.
   * @param {object} data email
   * @returns {object}
   *        status: true/false.
   *        data: array of object containg institution info like name, icon, isSSO.
   *        message: empty string or error message
   */

  institutionSignin = async (data) => {
    try {
      const { email } = data;
      const resp = await this.client.get(
        `/public/institutionSignin?email=${email}`,
      );
      return resp.data;
    } catch (error) {
      throw error;
    }
  };
}

export default new PublicAccessController(
  process.env.REACT_APP_API_BASE_URL_PUBLIC_ACCESS,
);
